
<div class="bg-[var(--header-bg-home,#134F82)] p-2 md:p-1 border-b-3 border-[#FFB95A] md:flex text-[white]">
    <div class="text-center">
        <h2 class="responsive-title md:mx-2 my-2">{{displayNameService}}</h2>
    </div>
</div>
<!-- <div *ngIf="hideHeader" class="p-5"></div> -->
<div class="flex flex-col md:flex-row w-full min-h-screen" style="padding-top: 0px !important;" >
    <!-- Mapa o Imágenes -->
    <div class="w-full md:w-1/2 h-64 md:h-screen"
        *ngIf=" formType !== 'Asistencia' && formType !== 'Asistencia Legal Automovilística' && formType !== 'Funeraria' && formType !== 'Asistencia Legal Funeraria' && !isSegundaOpinion() && !isConsultoriaMedicaTelefonica() && !isMedicalReferences() && !isUrgentMessages() && !isMedicoDomicilio() && !isRepatriacion() && !isDiscountNetwork() && !isConsultaMedicaVirtual() && !isConsultaMedicaPsicotelefonica() && !isConsultaMedica() && !isTrasladoFamiliar() && !isPagoHotel()">
        <app-map width="100%" height="100%" 
        [showSearchInput]="formType !== 'Check-up Médico' ? showMapSearchInput : false" 
        [useNewStructure]="true" mode="create"
        [laboratories]="formType === 'Check-up Médico' ? laboratories : []"
        [fromMedicalCheckup]="formType === 'Check-up Médico'"
            (getAddress)="getPlaces($event)" (getCordinate)="getReverseByCordinates($event)"
            [disableOpenStreetMap]="true"
            (getByAdreessByCordinate)="getReverseByAddress($event)"
            (laboratorySelected)="formType === 'Check-up Médico' ? onLaboratorySelectedFromMap($event) : null"
            (markersLoaded)="onMarkersLoaded($event)">
        </app-map>
        
        <!-- Overlay de laboratorios cuando viene desde medical checkup -->
        <div *ngIf="fromMedicalCheckup && laboratories.length > 0" class="absolute bottom-4 left-4 right-4 bg-white rounded-lg shadow-lg p-4 max-h-48 overflow-y-auto">
            <h3 class="font-semibold text-sm mb-2">Selecciona un laboratorio:</h3>
            <div class="space-y-2">
                <div *ngFor="let lab of laboratories" 
                     class="flex items-center justify-between p-2 border rounded cursor-pointer hover:bg-gray-50"
                     [class.bg-blue-50]="selectedLaboratoryId === lab.id"
                     [class.border-blue-300]="selectedLaboratoryId === lab.id"
                     (click)="selectLaboratory(lab)">
                    <div class="flex items-center text-xs">
                        <div class="w-3 h-3 bg-red-500 rounded-full mr-2"></div>
                        <div>
                            <p class="font-medium">{{ lab.name }}</p>
                            <p class="text-gray-600">{{ lab.distance }}km - {{ lab.address }}</p>
                        </div>
                    </div>
                    <mat-icon *ngIf="selectedLaboratoryId === lab.id" class="text-blue-600 text-sm">check_circle</mat-icon>
                </div>
            </div>
            
            <button *ngIf="selectedLaboratoryId" 
                    class="w-full mt-3 bg-blue-600 text-white py-2 px-4 rounded text-sm font-medium"
                    (click)="confirmLaboratorySelection()">
                Confirmar selección
            </button>
        </div>
    </div>
    <div *ngIf="formType === 'Asistencia Legal Automovilística'" class="w-full md:w-1/2 h-64 md:h-screen">
        <div class="w-full h-full flex items-center justify-center bg-gray-100">
            <img 
                src="/assets/images/legal/legal-auto.jpeg" 
                alt="Asistencia Legal Automovilística" 
                class="w-full h-full object-cover">
        </div>
    </div>  
    <!-- Form dinámico -->
    <div class="form-container" style="padding-top: 0px !important;"
        [class.medical-checkup-form]="isSegundaOpinion() || isConsultoriaMedicaTelefonica() || isMedicalReferences() || isUrgentMessages() || isMedicoDomicilio() || isRepatriacion() || isDiscountNetwork() || isConsultaMedicaVirtual() || isConsultaMedicaPsicotelefonica() || isConsultaMedica() || isTrasladoFamiliar() || isPagoHotel() || formType === 'Asistencia'">
        <div class="form-content"
            [class.medical-checkup-content]="isSegundaOpinion() || isConsultoriaMedicaTelefonica() || isMedicalReferences() || isUrgentMessages() || isMedicoDomicilio() || isRepatriacion() || isDiscountNetwork() || isConsultaMedicaVirtual() || isConsultaMedicaPsicotelefonica() || isConsultaMedica() || isTrasladoFamiliar() || isPagoHotel() || formType === 'Asistencia'">

            <ng-container [ngSwitch]="formType">
                <app-ambulance-assistance *ngSwitchCase="'Ambulancia'" [nameService]="nameService"
                    [currentMapLocation]="getCurrentMapLocation()" [isLoadingLocation]="isLoadingLocation"
                    [showMapSearchInput]="showMapSearchInput" [mapMovedManually]="mapMovedManually"
                    [serviceData]="getServiceData()"
                    (addressSelected)="onAddressSelected($event)"
                    (enableMapSearch)="enableMapSearch()" (disableMapSearch)="disableMapSearch()">
                </app-ambulance-assistance>
                <app-ambulance-international *ngSwitchCase="'Ambulancia Internacional'" [nameService]="nameService"
                    [currentMapLocation]="getCurrentMapLocation()" [isLoadingLocation]="isLoadingLocation"
                    [showMapSearchInput]="showMapSearchInput" [mapMovedManually]="mapMovedManually"
                    (addressSelected)="onAddressSelected($event)"
                    (enableMapSearch)="enableMapSearch()" (disableMapSearch)="disableMapSearch()">
                </app-ambulance-international>
                <app-ambulance-extranjero *ngSwitchCase="'Ambulancia (Extranjero)'" [nameService]="nameService"
                    [currentMapLocation]="getCurrentMapLocation()" [isLoadingLocation]="isLoadingLocation"
                    [showMapSearchInput]="showMapSearchInput" [mapMovedManually]="mapMovedManually"
                    (addressSelected)="onAddressSelected($event)"
                    (enableMapSearch)="enableMapSearch()" (disableMapSearch)="disableMapSearch()">
                </app-ambulance-extranjero>
                <app-traslado-familiar *ngSwitchCase="'Repatriación'">
                </app-traslado-familiar>
                <app-traslado-familiar *ngSwitchCase="'Traslado de un familiar'">
                </app-traslado-familiar>
                <app-pago-hotel *ngSwitchCase="'Pago de Hotel'">
                </app-pago-hotel>

                <app-vial-assistance *ngSwitchCase="'Arrastre de Grúa'" [currentMapLocation]="getCurrentMapLocation()"
                    [isLoadingLocation]="isLoadingLocation" [showMapSearchInput]="showMapSearchInput"
                    [mapMovedManually]="mapMovedManually"
                    [serviceData]="getServiceData()"
                    (addressSelected)="onAddressSelected($event)" (enableMapSearch)="enableMapSearch()"
                    (disableMapSearch)="disableMapSearch()">
                </app-vial-assistance>
                <app-vial-assistance *ngSwitchCase="'Paso de Corriente'" [currentMapLocation]="getCurrentMapLocation()"
                    [isLoadingLocation]="isLoadingLocation" [showMapSearchInput]="showMapSearchInput"
                    [mapMovedManually]="mapMovedManually"
                    [serviceData]="getServiceData()"
                    (addressSelected)="onAddressSelected($event)" (enableMapSearch)="enableMapSearch()"
                    (disableMapSearch)="disableMapSearch()">
                </app-vial-assistance>
                <app-vial-assistance *ngSwitchCase="'Cambio de Llanta'" [currentMapLocation]="getCurrentMapLocation()"
                    [isLoadingLocation]="isLoadingLocation" [showMapSearchInput]="showMapSearchInput"
                    [mapMovedManually]="mapMovedManually"
                    [serviceData]="getServiceData()"
                    (addressSelected)="onAddressSelected($event)" (enableMapSearch)="enableMapSearch()"
                    (disableMapSearch)="disableMapSearch()">
                </app-vial-assistance>
                <app-vial-assistance *ngSwitchCase="'Suministro de Gasolina'" [currentMapLocation]="getCurrentMapLocation()"
                    [isLoadingLocation]="isLoadingLocation" [showMapSearchInput]="showMapSearchInput"
                    [mapMovedManually]="mapMovedManually"
                    [serviceData]="getServiceData()"
                    (addressSelected)="onAddressSelected($event)" (enableMapSearch)="enableMapSearch()"
                    (disableMapSearch)="disableMapSearch()">
                </app-vial-assistance>
                <app-home-doctor *ngSwitchCase="'Medico a Domicilio'"></app-home-doctor>
                <app-medical-checkup *ngSwitchCase="'Check-up Médico'" 
                    [medicalCheckupData]="medicalCheckupData"
                    [fromServiceRequest]="true"
                    (laboratoriesFound)="onLaboratoriesFound($event)"
                    (laboratorySelected)="onLaboratorySelectedFromForm($event)"></app-medical-checkup>
                <app-reasons-legal-assistance
                    *ngSwitchCase="'Asistencia Legal Automovilística'"
                    [serviceType]="'Asistencia Legal Automovilística'"></app-reasons-legal-assistance>
                <app-reasons-legal-assistance
                    *ngSwitchCase="'Funeraria'"
                    [serviceType]="'Funeraria'"></app-reasons-legal-assistance>
                <app-reasons-legal-assistance
                    *ngSwitchCase="'Asistencia Legal Funeraria'"
                    [serviceType]="'Asistencia Legal Funeraria'"></app-reasons-legal-assistance>
                <app-segunda-opinion *ngSwitchCase="'Segunda Opinión'"></app-segunda-opinion>
                <app-medica-telefonica *ngSwitchCase="'Consultoría Médica Telefónica'"></app-medica-telefonica>
                <app-medical-references *ngSwitchCase="'Referencias Médicas'"></app-medical-references>
                <app-urgent-messages *ngSwitchCase="'Mensajes Urgentes'"></app-urgent-messages>
                <app-medico-domicilio *ngSwitchCase="'Médico a Domicilio'"></app-medico-domicilio>
                <app-discount-network *ngSwitchCase="'Red de Descuento'"></app-discount-network>
                <app-medical-virtual *ngSwitchCase="'Consulta Médica Virtual'"></app-medical-virtual>
                <app-medical-psicotelefonica *ngSwitchCase="'Asistencia Psicotelefónica'"></app-medical-psicotelefonica>
                <app-medical *ngSwitchCase="'Consulta Médica en Consultorio'"></app-medical>
                <div *ngSwitchDefault>
                    <app-default-click-to-call></app-default-click-to-call>   
                    
                </div>
            </ng-container>
        </div>
    </div>
</div>